var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerImg"},[_c('div',{staticClass:"headerTitle"},[_c('h2',{staticClass:"übertitle"},[_c('nobr',[_vm._v("Spezialisiert.")]),_vm._v(" "),_c('nobr',[_vm._v("Auf Unterstützung.")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }